import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['A partir de cierta hora, tu casa se convierte en un campo de batalla.', 'Tu bebé parece «incalmable» justo cuando tú ya no tienes más energía.', 'Has leído posts, visto vídeos, preguntado… y sigues en lo mismo.', 'Te descubres pensando: «me da miedo que llegue la tarde‑noche.»'];
  const mistakes = ['más cambios', 'más estímulos', 'más tensión en tu cuerpo', 'más desorganización en tu bebé'];
  return <section className="py-12 px-4 md:px-6 bg-[#faf6f0]" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        {/* Pain Identification */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-96">
          <h2 className="font-serif text-2xl md:text-4xl text-[#1a2e4a] font-bold mb-6 text-center" data-id="element-97">
            Si te pasa esto, estás en el lugar correcto
          </h2>

          <div className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-[#d4a0a0]/20" data-id="element-98">
            <ul className="space-y-3" data-id="element-99">
              {painPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-100">
                  <AlertCircle className="w-5 h-5 text-[#d4a0a0] flex-shrink-0 mt-0.5" data-id="element-101" />
                  <span className="text-base text-[#5a5a5a]" data-id="element-102">{point}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center mt-6" data-id="element-103">
            <p className="font-serif text-xl md:text-2xl text-[#1a2e4a] italic font-medium" data-id="element-104">
              No necesitas otro «truco» suelto. Necesitas un guion.
            </p>
          </div>
        </motion.div>

        {/* Problem Reframe */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#1a2e4a] text-[#faf6f0] p-5 md:p-10 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-105">
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#c4956a] rounded-full opacity-10 blur-3xl" data-id="element-106"></div>

          <h2 className="font-serif text-2xl md:text-4xl font-bold mb-4 relative z-10" data-id="element-107">
            El problema no es tu bebé (ni tú)
          </h2>

          <p className="text-base md:text-lg leading-relaxed mb-5 text-[#faf6f0]/90 relative z-10" data-id="element-108">
            El problema es el{' '}
            <span className="text-[#c4956a] font-bold" data-id="element-109">
              Tramo Crítico Tarde‑Noche
            </span>
            : una franja predecible donde se acumulan cansancio + hambre +
            sobreestimulación + pequeñas incomodidades.
          </p>

          <p className="text-base mb-4 relative z-10" data-id="element-110">
            Y cuando tú estás agotada, lo más humano es entrar en modo
            prueba‑error. Pero en esta franja, prueba‑error suele significar:
          </p>

          <div className="grid grid-cols-2 gap-3 mb-6 relative z-10" data-id="element-111">
            {mistakes.map((mistake, index) => <div key={index} className="flex items-center gap-2 bg-[#132238] p-3 rounded-lg border border-[#faf6f0]/10" data-id="element-112">
                <XCircle className="w-4 h-4 text-[#d4a0a0] flex-shrink-0" data-id="element-113" />
                <span className="font-medium text-sm" data-id="element-114">{mistake}</span>
              </div>)}
          </div>

          <div className="text-center relative z-10" data-id="element-115">
            <p className="font-serif text-2xl md:text-3xl text-[#c4956a] font-bold" data-id="element-116">
              Resultado: escalada.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}